import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import IMediaItem from '../../../interfaces/umbracoNodes/mediaItem';
import SVGIcon from '../SVGIcon';

const SVGLink = styled.a`
	display: inline-flex;

	svg {
		max-width: 100%;
	}
`;

type TProps = {
	children?: ReactNode;
	className?: string;
	href: string;
	icon?: IMediaItem;
	preserveIconDimensions?: boolean;
	id?: string;
	tabIndex?: number;
	target?: string | null;
	title?: string;
};

export const IconLink = ({
	children,
	className,
	href,
	icon,
	preserveIconDimensions,
	id,
	tabIndex,
	target,
	title,
}: TProps) => {
	return (
		<SVGLink
			{...(!href.startsWith('http') &&
				(!href.endsWith('pdf') || !href.endsWith('exe') || !href.endsWith('zip')) && { as: Link, to: href })}
			{...((href.startsWith('http') || href.endsWith('pdf') || href.endsWith('exe') || href.endsWith('zip')) && {
				href: href,
				target: target,
			})}
			aria-label={title || icon?.Name}
			className={className}
			id={id}
			rel="noreferrer"
			tabIndex={tabIndex}>
			{icon && <SVGIcon icon={icon} preserveDimensions={preserveIconDimensions} />}
			{children}
		</SVGLink>
	);
};

IconLink.defaultProps = {
	children: null,
	className: '',
	icon: undefined,
	preserveIconDimensions: false,
	id: '',
	tabIndex: 0,
	target: '_self',
	title: '',
};
